module.exports = __webpack_public_path__ + "static/media/SherrellSavage.f148375c.webp";